module.exports = __webpack_public_path__ + "img/stonesize-2.58ade94.png";